import React from 'react';
import formatPic from "../../assets/csvFormat.png"
const FileFormatModal = ({ onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
      <div className="bg-white p-6 rounded-lg shadow-lg text-center">
        <h2 className="text-xl font-bold mb-4">File Format: CSV</h2>
        <img
          src={formatPic} // Replace with your image URL
          alt="CSV Format Example"
          className="mx-auto mb-4"
        />
        <button
          onClick={onClose}
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default FileFormatModal;